import styled from "styled-components"

export const $Input = styled.input`
    width: 100%;
    padding: 10px;
    outline: none;
`